// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lickilicky: PokeData = {
  "id": 463,
  "name": "lickilicky",
  "height": 17,
  "weight": 1400,
  "base_experience": 180,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "slam",
    "stomp",
    "tackle",
    "wrap",
    "double-edge",
    "supersonic",
    "disable",
    "screech",
    "defense-curl",
    "lick",
    "rest",
    "belly-drum",
    "rollout",
    "knock-off",
    "refresh",
    "gyro-ball",
    "wring-out",
    "me-first",
    "giga-impact",
    "zen-headbutt",
    "power-whip",
    "chip-away",
    "bulldoze"
  ],
  "moves": [
    "tackle",
    "supersonic",
    "lick",
    "refresh",
    "zen-headbutt",
    "power-whip",
    "scary-face",
    "body-slam",
    "purification",
    "leer",
    "quick-attack",
    "protect",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 48,
    "item": null,
    "species": [
      {
        "name": "lickitung",
        "order": 119,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lickilicky",
        "order": 120,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 108,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "rollout"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 173,
    "speed": 84,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
